import getItem from 'owa-mail-store/lib/services/getItem';
import checkIfResponseSuccess from 'owa-mail-store/lib/services/utils/checkIfResponseSuccess';
import { ClientItem } from 'owa-mail-store';
import ItemInfoResponseMessage from 'owa-service/lib/contract/ItemInfoResponseMessage';
import ItemResponseShape from 'owa-service/lib/contract/ItemResponseShape';
import MimeContentType from 'owa-service/lib/contract/MimeContentType';
import SingleResponseMessage from 'owa-service/lib/contract/SingleResponseMessage';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';

function getMessageSourceResponseShape(): ItemResponseShape {
    return itemResponseShape({
        BaseShape: 'IdOnly',
        IncludeMimeContent: true,
    });
}

function processResponseMessage(responseMessage: SingleResponseMessage[]): MimeContentType {
    if (checkIfResponseSuccess(responseMessage[0])) {
        const responseItem = responseMessage[0] as ItemInfoResponseMessage;
        return responseItem.Items[0].MimeContent;
    }
    return null;
}

export function loadMessageSource(item: ClientItem): Promise<MimeContentType> {
    return getItem(
        [item.ItemId.Id],
        getMessageSourceResponseShape(),
        null /* shapeName */,
        'V2016_06_24',
        item.MailboxInfo?.requestOptions
    ).then(responseMessage => {
        return processResponseMessage(responseMessage);
    });
}
